import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type CommonState = {
  darkMode: boolean;
};

const loadDarkMode = (): boolean => {
  try {
    const saved = localStorage.getItem('user.darkMode');
    return saved ? JSON.parse(saved) : true;
  } catch {
    return true;
  }
};

const initialState: CommonState = {
  darkMode: loadDarkMode(),
};

const userSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
      localStorage.setItem('user.darkMode', JSON.stringify(action.payload));
    },
  },
});

// actions
export const { setDarkMode } = userSlice.actions;

// selectors
// ...

// reducer
export default userSlice.reducer;
